import * as PIXI from 'pixi.js'
export const Loader = new PIXI.Loader()
export const TextureCache = new Map()

const atlases = ['atlas0.json', 'atlas1.json', 'atlas2.json', 'atlas3.json']

export const load = () => new Promise(resolve => {
  atlases.forEach(atlas => Loader.add(`atlas/${atlas}`))
  Loader.load(() => {
    atlases.forEach(atlas => {
      const textures = Loader.resources[`atlas/${atlas}`].textures
      Object.keys(textures).forEach(key => TextureCache.set(key, textures[key]))
    })
    resolve(true)
  })
  // console.log(TextureCache)
})

export function createSprites (mobile) {
  return {
    intro: createIntroSprite(mobile),
    burst: createIntroSprite(mobile, true),
    outro: createOutroSprite(mobile)
  }
}

function createIntroSprite (mobile, burst) {
  const sequence = []
  for (let i = 0; i < 3; i++) {
    sequence.push(TextureCache.get(`Title_${i}.png`))
  }
  const sprite = new PIXI.AnimatedSprite(sequence)
  if (burst) {
    sprite.gotoAndStop(2)
  }
  if (mobile) {
    sprite.x = 810 / 2
  } else {
    sprite.x = 1920 / 2
  }
  sprite.anchor.x = 0.5
  sprite.y = 1080 / 2
  sprite.anchor.y = 0.5
  sprite.scale.x = 100
  sprite.scale.y = 100
  sprite.alpha = 0
  sprite.loop = false
  return sprite
}

function createOutroSprite (mobile) {
  const sequence = []
  for (let i = 0; i < 16; i++) {
    sequence.push(TextureCache.get(`TrickyAvocados_${i.toString().padStart(5, '0')}.png`))
  }
  const sprite = new PIXI.AnimatedSprite(sequence)
  sprite.x = (mobile ? 810 : 1920) / 2
  sprite.y = 1080 / 2 - (mobile ? 200 : 100)
  sprite.scale.x = mobile ? 1 : 1.15
  sprite.scale.y = mobile ? 1 : 1.15
  sprite.anchor.x = 0.5
  sprite.anchor.y = 0.5
  sprite.animationSpeed = 0.5
  sprite.loop = false
  return sprite
}